import { render, staticRenderFns } from "./BlogPostGallery.vue?vue&type=template&id=ffd9afd4&"
import script from "./BlogPostGallery.vue?vue&type=script&lang=js&"
export * from "./BlogPostGallery.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostGallery.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports